import React from "react";
import Button from "../../components/Button/Button";
import accountIcon from "../../assets/icons/account-white.svg"
import {Fields, Form, Input} from "../../components/Form/Form";
import useForm from "../../hooks/useForm";
import useUserService from "../../api/services/useUserService";

const UserInvite = () => {

  const form = useForm()
  const {userInvite} = useUserService()

  return (
    <div>
      <Button
        label="Terug naar mijn-standplaats"
        link={'/user/mijn-standplaats'}
        icon={accountIcon}
      />
      <h1>Nodig anderen uit voor Standplaats.nl</h1>
      <Form>
        <Fields
          form={form}
          initData={{email: ''}}
          apiService={{
            userStore: userInvite,
          }}
          updateSuccess={() => {
            form.formData.model.email = ''
            form.save(false)
          }}
          GAEventLabel="User Invited other user"
          buttonConfirmLabel="Uitnodigen"
        >
          <p>Vul het e-mailadres in van iemand die je wilt uitnodigen. Zodra zij een account aanmaken, ontvang jij 200 Stand credits. Je kunt meerdere uitnodigingen sturen, één per e-mailadres.</p>
          <Input
            label="E-mailadres"
            name="email"
            type="email"
            autoFocus="autofocus"
          />
        </Fields>
      </Form>
    </div>
  )
}

export default UserInvite
